import classNames from "classnames";
import { useEffect, useState } from "react";
import { Col, Row, ProgressBar, Badge } from "react-bootstrap";

type ProgressStepBarProps = {
    now: number;
    steps: string[];
}

export function ProgressStepBar({ now, steps }: ProgressStepBarProps) {
    const [progressBarPercentage, setProgressBarPercentage] = useState(1);

    useEffect(() => {
        let newNow = now;
        if (newNow > 1) newNow = newNow * 2 - 1;

        setProgressBarPercentage(100 / (steps.length * 2) * (newNow));
    }, [now, steps]);

    return (
        <div className="ms-4 me-4 mb-3 mt-2 progress-step-bar">
            <Row>
                {steps.map((step, index) => (
                    <Col key={index} sm={3} className="d-flex flex-column align-items-center">
                        <p>
                            <span className="ps-1 pe-1">
                                <Badge className={classNames("light", "bg-primary", now < index + 1 && "disable-badge")}>{index + 1}</Badge>
                            </span>
                        </p>
                        <p style={{textAlign:"center"}}>{step}</p>
                    </Col>
                ))}
            </Row>
            <ProgressBar now={progressBarPercentage} variant="primary" style={{ height: 3 }} className="mb-3 progress-sm"/>
        </div>
    );
}